const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPremiumFeaturesGraphic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 350 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 36.68,
    y: 77.59,
    width: 276,
    height: 227.69,
    style: {
      fill: "#ebf2f9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.76,271.45s.5,5.73-.71,6.33l-15.52,0s0-1.79,2.49-2.19,6.87-1.86,7.61-5.11S206.76,271.45,206.76,271.45Z",
    style: {
      fill: "#233862"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.28,269.23s.47,7.95-.74,8.55l-15.52,0s0-1.79,2.49-2.19,6.87-1.86,7.61-5.11S251.28,269.23,251.28,269.23Z",
    style: {
      fill: "#233862"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.81,270.21a29.27,29.27,0,0,1-4.4,1.87,19.17,19.17,0,0,1-4.21.12c-5.28-14.15-21.65-71.66-21.65-71.66A249.13,249.13,0,0,1,215,245.05q-.12.52-.24,1h0c-.07.3-.15.61-.22.91a.08.08,0,0,1,0,0c-3.62,15-7.25,25.29-7.25,25.29s-.93,1.18-3.54.64c-3-.62-4-1.93-4-1.93,1.94-61.28,3-95.83,3-95.83s25.9-14,32.93-2S251.81,270.21,251.81,270.21Z",
    style: {
      fill: "#2a4e96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.37,181.43c-3.36-12-3.91-23.41-3.88-32.84,0-13.44,1.24-22.9-2.8-24.49,0,0-12.49-3.63-21.09-5.23a42.15,42.15,0,0,0-4-2c-2.72-1.1-13.3-16.48-15.09-20.17S189.7,77,189.7,77l-4.12,1.32s-1.24,18-.65,22.71,13.7,24.88,14.79,26.65h0c4.66,17.05,0,44.8,2.13,51,1.1,3.19,21.44,9,32.57,8.28.55,0,1.08-.09,1.59-.16h0c2.64-.36,4.55-1.2,5.26-2.68A3.67,3.67,0,0,0,241.37,181.43Z",
    style: {
      fill: "#aec3ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.7,77s2.33-6.77.63-7-6-.18-6.51,1,1.76,7.32,1.76,7.32Z",
    style: {
      fill: "#ffb27d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.34,93.82,131.58,85.5a4.29,4.29,0,0,1,5.87-1.44,1.87,1.87,0,0,0,2.58-.64l3.73-6.15L147,79.21l-3.72,6.16A1.86,1.86,0,0,0,143,86.8a1.89,1.89,0,0,0,.85,1.16,4.27,4.27,0,0,1,1.45,5.86Z",
    style: {
      fill: "#ed7d2b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.34,93.82l-9.15-5.53c-2.12-1.76-1.08-3.28,0-3.54a4.29,4.29,0,0,1,3.24.49,1.87,1.87,0,0,0,2.58-.63l3.72-6.16,1.27.76-3.72,6.16A1.86,1.86,0,0,0,143,86.8a1.89,1.89,0,0,0,.85,1.16,4.27,4.27,0,0,1,1.45,5.86Z",
    style: {
      fill: "#f99746"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.58,53.72l-11.14,14a20.57,20.57,0,0,1-17,9.73h0a20.66,20.66,0,0,1-6.33-.7,4.28,4.28,0,0,0-4.6,2.17l-.21.36c-.65,1.06-1.19,2-1.19,2l-2.35-1.42,1.2-2a4.81,4.81,0,0,0-.17-5.61,20.71,20.71,0,0,1-2.25-24.38l7.54-16.21Z",
    style: {
      fill: "#f99746"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139,59.26c.91-5.25-1.63-8.12-4.33-11.15-2.15-2.43-4.38-4.93-4.85-8.67a10.93,10.93,0,0,1,4.79-10.51,7.06,7.06,0,0,1,7.84-.15c3.41,2.19,4.67,6.42,3.66,12.25a34.74,34.74,0,0,1-2.41,7.84l-2.14-1c.06-.12,6-13-.38-17.11a4.8,4.8,0,0,0-5.31.16,8.66,8.66,0,0,0-3.72,8.22c.39,3,2.28,5.15,4.29,7.4,2.8,3.17,6,6.75,4.88,13.13Z",
    style: {
      fill: "#ed7d2b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.55,75.31c4.23-3.24,7.95-2.32,11.89-1.35,3.14.78,6.4,1.59,9.93.28a10.92,10.92,0,0,0,7.08-9.13,7,7,0,0,0-3.51-7c-3.52-2-7.86-1.16-12.54,2.44a35.08,35.08,0,0,0-5.83,5.78l1.87,1.43c.09-.11,8.8-11.32,15.34-7.6a4.79,4.79,0,0,1,2.32,4.77A8.63,8.63,0,0,1,186.55,72c-2.85,1.06-5.62.37-8.55-.35-4.1-1-8.75-2.17-13.88,1.76Z",
    style: {
      fill: "#f99746"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.47,77.48a20.66,20.66,0,0,1-6.33-.7,4.28,4.28,0,0,0-4.6,2.17l-.21.36a3.56,3.56,0,0,0-1.74,1.63l-1.8-1.09,1.2-2a4.81,4.81,0,0,0-.17-5.61,20.71,20.71,0,0,1-2.25-24.38l7.54-16.21,6,3.64S130.66,68.48,157.47,77.48Z",
    style: {
      fill: "#ed7d2b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.62,82.69l-6-3.63a1.73,1.73,0,0,1-.58-2.38h0a1.73,1.73,0,0,1,2.38-.58l6,3.63a1.74,1.74,0,0,1,.59,2.38h0A1.74,1.74,0,0,1,146.62,82.69Z",
    style: {
      fill: "#f99746"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.46,62.51l.64-1.07c3.05,1.65,3.45,1.46,4.7-.61l6.31-10.43c.89-1.47.44-1.9-.66-2.76l-.77-.67.57-.95a36.47,36.47,0,0,0,7.27,2.43l-8.89,14.69c-1.29,2.13-1.27,2.5,1.58,4.42l-.64,1.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.82,71s-.22,2.34.53,2.77,1-2.77,1-2.77,0,2.64.61,2.82.93-3,.93-3,.06,2.56.45,2.47.65-2.47.65-2.47.17,1.86.7,1.52,1-2.32,1-2.32Z",
    style: {
      fill: "#ffb27d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.7,77a6.64,6.64,0,0,0,2-2.39c.35-1.14,1.38-3.07.83-3.3s-2.15,2.24-2.15,2.24Z",
    style: {
      fill: "#ffb27d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.33,117l-.2,1s-.93,3.2,3,4.47,7.21,1.86,7.6-.68a55.44,55.44,0,0,1,.27-6.77,11,11,0,0,1,.53-1.92l-7.74-1.69-2.36-.08Z",
    style: {
      fill: "#ffb27d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.41,111.39l-.72,3.8c7.35,1.94,10.56-1.34,10.82-2l-7.74-1.69Z",
    style: {
      fill: "#e2915a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.64,111.58c-2.28,4.63-8.54,2.7-11.18,1.63-.74-.3-1.2-.53-1.2-.53-.8-.48-.9-2-.62-3.82.54-3.65,2.56-8.68,3.53-9.84,1.46-1.74,3.75-3.42,9.67-.09S232.56,105.65,229.64,111.58Z",
    style: {
      fill: "#ffb27d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.53,93.82a21.74,21.74,0,0,0,6.55.06c3-.41,6,1.82,6.95,2.71a1.7,1.7,0,0,0-.08-.74,1.57,1.57,0,0,1,.33,1c0,.05.06.08,0,.08a2,2,0,0,1,.9.32s-.24-.11-.38,0a.05.05,0,0,1-.05,0c3.61,3.19,2.14,9.9.37,11a48.23,48.23,0,0,0-5.79,5.19,9.46,9.46,0,0,1,.88-2.93c.74-1.53-.65-1.92-2.21-3.15s.49-2.88-.7-4.56-7.05-2.53-6.71-3.47C217.74,98.09,219.47,94,219.53,93.82Z",
    style: {
      fill: "#233862"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.47,109.87s-.39.58-1.91-.1c0,0-1.28-.57-1-1.24A4.52,4.52,0,0,1,220.47,109.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.75,125.53s-3.53,23.41-29.92,39.67l-2.46,7.15h9.52s23.64-19.81,25.22-46.14Z",
    style: {
      fill: "#ed7d2b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.75 125.53 218.75 121.98 223.1 123.22 221.11 126.21 218.75 125.53",
    style: {
      fill: "#db6516"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.33,117l-2.55,2.18a10,10,0,0,0,1,6.33l5.13-2.93A7.3,7.3,0,0,1,217.33,117Z",
    style: {
      fill: "#9db0f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.92,122.6a9.47,9.47,0,0,0,1.85,4.12s5.78-1,7.38-3.78l-2.42-3.78S227.15,121.74,220.92,122.6Z",
    style: {
      fill: "#9db0f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.55,183.28s0,5.24-.47,6.28-2.64,4.44-3.64,5.16.21-4.19-.1-5.09-.7,1.77-1.16,1.88-.58-2.25-.69-3.1,2-3.2,2.58-5.1S255.55,183.28,255.55,183.28Z",
    style: {
      fill: "#ffb27d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.61,124.1s5.08,1.38,8.52,9c3.61,7.95,13.28,25.6,13.64,28s-.64,25.19-.64,25.19-4.23.17-5.54-1.84c0,0-1.47-20-2.12-21.06s-17.3-20.94-15.9-26A88,88,0,0,0,234.61,124.1Z",
    style: {
      fill: "#aec3ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.27,184.05a13.84,13.84,0,0,1-5.26,2.68h0a4,4,0,0,1-1.59.16c-9.31-.95-7.87-37.09-3.37-39.77,4.75-2.81,6.44,1.47,6.44,1.47,0,9.43.52,20.83,3.88,32.84A3.67,3.67,0,0,1,241.27,184.05Z",
    style: {
      fill: "#9db0f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.53,247c.06-.28.14-.59.22-.91C214.68,246.38,214.6,246.69,214.53,247Z",
    style: {
      fill: "#233862"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,245.05c2.85-13.47-.22-49.57,1.15-50.25s5.41,5.74,5.41,5.74A249.13,249.13,0,0,1,215,245.05Z",
    style: {
      fill: "#233862"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.39 272.57 144.57 266.66 148.02 263.78 149.1 271.6 145.39 272.57",
    style: {
      fill: "#ffb27d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.84,277.85H142.79a7.74,7.74,0,0,1,.39-3.77c.71-1.56,1.8-2.52,1.9-3.71a4.2,4.2,0,0,0,4,1.23,15.15,15.15,0,0,0,2.44,3.16C152.46,275.42,156.55,275.19,156.84,277.85Z",
    style: {
      fill: "#233862"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,192.78c-.92,7.39-1.67,14.36-2.28,20.85-3.27,34.61-2.63,55.76-2.63,55.76s-.23.62-2.26.63a11.43,11.43,0,0,1-2.27-.24s-7.32-22.6-6.75-35.46a19.44,19.44,0,0,1,.57-4.16c1.75-6.58-6.5-31.74,2.47-41.11S154.44,189.39,154,192.78Z",
    style: {
      fill: "#f99746"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,192.78c-.92,7.39-1.67,14.36-2.28,20.85l-13.91,20.69a19.44,19.44,0,0,1,.57-4.16c1.75-6.58-6.5-31.74,2.47-41.11S154.44,189.39,154,192.78Z",
    style: {
      fill: "#ed7d2b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.07,122.28s-.34-1.69-.72-3c-.17-.57,1-4.32,1.82-4.78s2.94,2.06,2.34,4c-.31,1-.82,4.23-.82,4.23Z",
    style: {
      fill: "#ffb27d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.07,122.28s-.44-1-.84-1.14-.83-1.76-1.12-2.4c0,0,.28-.41.78.12.3.33,1,1.28,1,1.28Z",
    style: {
      fill: "#ffb27d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.07,128c-.08.17-.2.49-.31.79v-.24c0-.59-2.23-3.83-3.14-4s-2.21,2.83-1.07,4.5c.59.86,2,3.81,2,3.81l2.37-1.22s.13-1.07.47-1.34.28-1.92.37-2.61C107.78,127.62,107.39,127.3,107.07,128Z",
    style: {
      fill: "#ffb27d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.83,270.8c-.2-1.9-.25-6.88-.25-6.88s5.08-1.62,4.89-.51a35.8,35.8,0,0,0-.67,8.19l-2,1.23Z",
    style: {
      fill: "#ffb27d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.77,192.43s-19.61,53.76-23.47,77.09a4,4,0,0,1-2.57.41,2.87,2.87,0,0,1-2.41-1.55s-3.54-27.95,3.5-37.66c4.84-6.66-2.08-35.95,9.19-38.29S149.77,192.43,149.77,192.43Z",
    style: {
      fill: "#f99746"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.29,140.7h0a.25.25,0,0,0,0-.07c-.11-.47-.24-.94-.37-1.4h0a31.34,31.34,0,0,0-1.43-3.95,20.33,20.33,0,0,0-.94-1.87l-.14-.26h0a5.66,5.66,0,0,0-2.24-2.42,6.73,6.73,0,0,0-3.69-.16,1.66,1.66,0,0,1,.7-.47,5.63,5.63,0,0,0-1.91.81c-9-2-8.5,10.76-7.89,13.66s-2.3,4.3-6.4,7.27c-7.83,5.65-7.69,11.65-7.69,11.65l.22.1c.32-.77,1-2.24,1.69-2.55,0,.07-.59,2-.76,3,1.2.66,2.85,1.68,4.64,2.83h0c2.4,1.53,5,3.3,7.17,4.73a5,5,0,0,1-.06-1.88l.68,2.09.09.27,3,2,.15.1.24.17c-.18-.74.61-2.67,1.94-5.1.09-.17.19-.34.28-.52.43-.76.91-1.57,1.42-2.41l.57-.91h0l.48-.74h0c.38-.59.78-1.19,1.19-1.79,1.05-1.55,2.16-3.09,3.26-4.5a38.89,38.89,0,0,1,4.47-5l.12-.27a8.48,8.48,0,0,0,.48-1.55c0-.16.08-.32.11-.49a20.93,20.93,0,0,0,.32-3.83,21.46,21.46,0,0,1,0,3.86c0,.21-.06.4-.09.58h0a9.43,9.43,0,0,1-.23,1,6,6,0,0,0,.57-.88,6.4,6.4,0,0,0,.29-.65C147.49,148.51,147.21,144.48,146.29,140.7Z",
    style: {
      fill: "#163560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.59,153.65s-2.53,1.86-4.7,1.6-3.7-2.59-3.67-2.6c.8-.29.87-1.47.12-6.38l.39,0,6.5.31s.16,2,.43,3.89C143.89,152.06,144.21,153.54,144.59,153.65Z",
    style: {
      fill: "#ffb27d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.23,146.6s.16,2,.43,3.89c-3.55.42-5.9-2.52-6.93-4.2Z",
    style: {
      fill: "#ed975d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,145.7a18.79,18.79,0,0,1-3.11-5.09c-.58-1.74-.66-8.5,6.14-8.53a9.09,9.09,0,0,1,4,.86c1.59.76,4,2.56,2.52,8.68l-.32,2Z",
    style: {
      fill: "#163560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.83,191.39a27.54,27.54,0,0,1-19.08,2.45L127,192.43c.14-.41,1.26-7.07,1.4-7.44,1.89-4.86,5.33-31.27,8.21-32.57.74.8,2.84,1.35,4.64,1.19,2.07-.18,2.76-1.08,2.59-2,2.29,1.08,4,2.09,4,2.09C150,156.8,154.83,191.39,154.83,191.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.68,148.2s-8.35,1.38-9.13-3.83-2.38-8.53,2.91-9.64,6.63.73,7.32,2.41S146.83,147.71,144.68,148.2Z",
    style: {
      fill: "#ffb27d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.26,134s-1.39,6.45-4.77,7.88-5,.71-5,.71a10,10,0,0,0,2.38-6.36S140.09,131.39,142.26,134Z",
    style: {
      fill: "#163560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.76,134.62a7.54,7.54,0,0,1,2.53,2.37c.61,1.27,1.21,4,2,3.76,0,0,1.11-4.41-1.18-6.47S141.76,134.62,141.76,134.62Z",
    style: {
      fill: "#163560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.75,122.4a5.06,5.06,0,0,0-1.49-.46,4.44,4.44,0,0,0-1.31.13s-2.36,14.64-2.53,15.41-10.1,12-12.77,11.91c-2.42,0-5.28,1.82-5.81,2.18,0,0,5.62,11.9,5.9,14.13.31,2.43,3.22,39.87,3.22,39.87s-.17,1.75,3.08.81,4.07-1.71,4.07-1.71-3-29.48-3.62-38.64a17.06,17.06,0,0,0-.57-3.43,3.47,3.47,0,0,1,.56-2.94c4.12-5.65,10.62-14.8,11-16.74C168,140.06,167.75,122.4,167.75,122.4Z",
    style: {
      fill: "#2b478b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.54,277.85h-14a7.74,7.74,0,0,1,.39-3.77c.71-1.56,1.8-2.52,1.9-3.71a4.2,4.2,0,0,0,4,1.23,15.15,15.15,0,0,0,2.44,3.16C129.16,275.42,133.25,275.19,133.54,277.85Z",
    style: {
      fill: "#233862"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.19,166.86c-.48-2.92-6.52-14.62-6.52-14.62s-3.82-1.14-6.34-.23-15.53-6.44-16-7.11S107,131.23,107,131.23a1.64,1.64,0,0,0-1.51.15,1.71,1.71,0,0,0-.92,1.41s5.38,16.35,6.81,18.88c.87,1.53,8.12,6.84,13.75,10.82a3.52,3.52,0,0,1,1.46,3.35c-.76,5.6-1,8.75-1.82,18.34-.72,8-1,23.38-1,23.38A52.37,52.37,0,0,0,134.41,210c4.35.29,5.3-4.29,5.3-4.29S143.67,169.85,143.19,166.86Z",
    style: {
      fill: "#2b478b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.94,145.63a3.76,3.76,0,0,0,2.21.41c.82-.12,1-1.09,1-1.09a3.25,3.25,0,0,0-1.48,0A6.2,6.2,0,0,0,141.94,145.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.51,90.21a9.5,9.5,0,0,1,1.7,5.58,8.68,8.68,0,0,1-2.25,4.52l3.11,1.66s2.3-4.09,1.52-7.5A8.76,8.76,0,0,0,119.44,91,3,3,0,0,0,117.51,90.21Z",
    style: {
      fill: "#6bb7bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.17,90.48l-2-4.34s9.18.31,12.22,7.78C121.42,93.92,115,89.34,111.17,90.48Z",
    style: {
      fill: "#86d1cd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.51,201a8.16,8.16,0,0,1-2.75-4.12,7.29,7.29,0,0,1,.72-4.23l-2.93-.58s-.87,3.88.6,6.47a7.47,7.47,0,0,0,2.6,2.29A2.51,2.51,0,0,0,76.51,201Z",
    style: {
      fill: "#6bb7bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6,199.26l2.67,3.05s-7.53,2-11.84-3.33C72.43,199,78.77,201.12,81.6,199.26Z",
    style: {
      fill: "#86d1cd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.1,66.9a5.37,5.37,0,0,1,7.62-1.26L235.53,63s-2.63-2-8.68,1.58C222.89,66.87,225.1,66.9,225.1,66.9Z",
    style: {
      fill: "#5685d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.14,71.15s-.6-5,7.72-8.07c0,0-3,1.45-3.93,6.41Z",
    style: {
      fill: "#739af0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.55,44.79s2.46-1.55,2.72-3.43c0,0,2.39.13,2.91.91,0,0-1.1,3.1-2.39,3.69C258.79,46,255.88,46.15,255.55,44.79Z",
    style: {
      fill: "#f99746"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.45,221.92s-2.62-1.66-2.9-3.66c0,0-2.55.14-3.1,1,0,0,1.17,3.31,2.55,3.93C173,223.16,176.11,223.37,176.45,221.92Z",
    style: {
      fill: "#f99746"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.09,93.7S286.72,92,287,90c0,0,2.56.14,3.12,1,0,0-1.18,3.33-2.57,4C287.55,95,284.43,95.16,284.09,93.7Z",
    style: {
      fill: "#86d1cd"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumFeaturesGraphic);
export default __webpack_public_path__ + "static/media/premium_features_graphic.5006bdbe3f0bcdd85f2cadda26a5fe4b.svg";
export { ForwardRef as ReactComponent };